import { Form } from 'react-bootstrap';

function DonorListSampleType({ label, selectedSamples, sample, id, handleSampleChange ,setFieldValue}) {
    const isChecked = selectedSamples.includes(sample.id);   
     const checkboxId = `status-${label}-${id}`;
    return (
        <Form.Group controlId={id}>
            <Form.Check 
                  id={checkboxId} 
                type="checkbox" 
                label={label}
                checked={isChecked} 
                onChange={() => {handleSampleChange(sample.id, setFieldValue);}}   
            />
        </Form.Group>
    );
}

export default DonorListSampleType;
